module.exports = __webpack_public_path__ + "img/expert-teams.56a72c37.svg";